import PropTypes from 'prop-types';
import { useEffect, useState, memo } from 'react';
import { restApi } from '@icp/settings';

function ImportCss(props) {
  const { url, children, manualLoad } = props;

  const [cssContent, setCssContent] = useState(null);

  useEffect(() => {
    if (!url) return;
    if (!manualLoad) return;
    restApi.get(url, { responseType: 'text', noTimestamp: true }).then(setCssContent);
  }, [manualLoad, url]);

  return (
    <>
      <style>{`:host(.design-mode) * { user-select: none; pointer-events: none; }`}</style>
      {url && !manualLoad ? <style>{`@import url("${url}");`}</style> : null}
      {cssContent ? <style>{cssContent}</style> : null}
      {children}
    </>
  );
}

ImportCss.propTypes = {
  url: PropTypes.string,
  children: PropTypes.node,
  manualLoad: PropTypes.bool,
};

export default memo(ImportCss);
